<script context="module">
	import '../app.css';
	import { goto } from '$app/navigation';
	import Button from '$lib/components/Button.svelte';
</script>

<div class="flex items-center justify-center bg-white" style="height:100vh">
	<div class="flex flex-col items-center justify-center">
		<img src={'/origin/errorPage.svg'} alt="" />
		<div class="font-bold text-[42px] leading-7 my-7 text-primary-300">404 ERROR</div>
		<div class="font-bold text-black text-[20px]">죄송합니다.</div>
		<div class="font-bold text-black text-[20px]">요청하신 페이지를 찾을 수 없습니다.</div>
		<div class="font-normal mt-2 text-[#575757] text-[14px]">
			존재하지 않는 주소를 입력하셨거나,
		</div>
		<div class="font-normal text-[#575757] text-[14px]">
			요청하신 페이지의 주소가 변경 / 삭제되어 찾을 수 없습니다.
		</div>
		<div class="mt-[26px] w-[136px]">
			<Button on:click={() => goto('/')} class="!w-full whitespace-nowrap" text="홈으로 돌아가기" />
		</div>
	</div>
</div>
